import api from './api'

const getCareerTitles = () => api.get('/api/careers/search/titles?pageSize=2000')

const careerTitlesService = {
  getCareerTitles,
}

export default careerTitlesService
